var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEntityOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / Entity",
    clipPath: "url(#clip0_36571_67117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67222 9.33333L1.67222 4.57169C0.705538 4.28662 0 3.39237 0 2.33333C0 1.04467 1.04467 0 2.33333 0C3.39237 0 4.28662 0.705537 4.57168 1.67222H9.33333V0H14V4.66667H12.3278V9.42831C13.2945 9.71338 14 10.6076 14 11.6667C14 12.9553 12.9553 14 11.6667 14C10.6076 14 9.71338 13.2945 9.42831 12.3278H4.66667V14H0V9.33333H1.67222ZM3.34444 2.33333C3.34444 2.89175 2.89175 3.34444 2.33333 3.34444C1.77491 3.34444 1.32222 2.89175 1.32222 2.33333C1.32222 1.77491 1.77491 1.32222 2.33333 1.32222C2.89175 1.32222 3.34444 1.77491 3.34444 2.33333ZM2.99444 4.57169C3.75153 4.34843 4.34843 3.75152 4.57169 2.99444H9.33333V4.66667H11.0056L11.0056 9.42831C10.2485 9.65157 9.65157 10.2485 9.42831 11.0056H4.66667V9.33333H2.99444L2.99444 4.57169ZM12.6778 11.6667C12.6778 12.2251 12.2251 12.6778 11.6667 12.6778C11.1082 12.6778 10.6556 12.2251 10.6556 11.6667C10.6556 11.1082 11.1082 10.6556 11.6667 10.6556C12.2251 10.6556 12.6778 11.1082 12.6778 11.6667ZM12.6778 1.32222H10.6556V3.34444H12.6778V1.32222ZM1.32222 12.6778V10.6556H3.34444V12.6778H1.32222Z",
    fill: "var(--secondary-6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36571_67117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityOutlined);
export default __webpack_public_path__ + "static/media/entityOutlined.0e8706818b0cebe815d72f22a73e2b94.svg";
export { ForwardRef as ReactComponent };